/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import { ProgressIndicatorProps } from './progressBarIndicatorTypes';
import styles from './progressIndicator.module.scss';

const ProgressBar: FC<ProgressIndicatorProps> = (props: ProgressIndicatorProps) => {
    const { direction, value, height = '90%' } = props;

    return (
        <div className={styles['progress-indicator']} style={{ '--height': height } as any}>
            <div
                data-testid="progress-indicator"
                className={styles[direction === 'horizontal' ? 'horizontal' : 'vertical']}
            >
                {value === 0 ? (
                    <div className={styles['no-value']}>
                        <div className={styles.current}></div>
                        {direction === 'horizontal' && <div className={styles['current-completion']} />}
                    </div>
                ) : (
                    <div className={styles.value} style={{ '--value': `${value}%` } as any}>
                        {value !== 100 && (
                            <>
                                <div className={styles.current}></div>
                                {direction === 'horizontal' && <div className={styles['current-completion']} />}
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProgressBar;
